import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderByAlpha',
  standalone: false
})
export class OrderByAlphaPipe implements PipeTransform {
  transform(value: any[], property?: string): any[] {
    if (!value || !Array.isArray(value)) {
      return value;
    }

    // Create a copy to avoid mutating the original array
    const sortedArray = [...value];

    return sortedArray.sort((a, b) => {
      let aValue: string;
      let bValue: string;

      // If property is provided, sort by that property (for arrays of objects)
      if (property) {
        aValue = a && a[property] ? String(a[property]).toLowerCase() : '';
        bValue = b && b[property] ? String(b[property]).toLowerCase() : '';
      } else {
        // Otherwise, sort by the value itself (for arrays of strings)
        aValue = a ? String(a).toLowerCase() : '';
        bValue = b ? String(b).toLowerCase() : '';
      }

      if (aValue < bValue) {
        return -1;
      }
      if (aValue > bValue) {
        return 1;
      }
      return 0;
    });
  }
}

